import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallGetVerifyRegistration, ApiCallPost, ApiCallPut } from "../apiConfig/apiCall";
import { ConsoleLogs } from "../../utils/ConsoleLogs";

const TAG = "AuthService";

const AuthService = {

  login: async (signId, password, token) => {
    const { baseAuth, login } = ApiConfig;
    const url = baseAuth + login;
    const params = {
      email_or_phone: signId,
      password: password,
      token
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  registerEmail: async (signId, password, invitation, token) => {
    const { baseAuth, registerEmail } = ApiConfig;
    const url = baseAuth + registerEmail;
    const params = {
      email: signId,
      password: password,
      referral_code: invitation,
      token: token,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },


  registerPhone: async (signId, password, invitation, countryCode, token) => {
    const { baseAuth, registerPhone } = ApiConfig;
    const url = baseAuth + registerPhone;
    const params = {
      phone: signId,
      password: password,
      referral_code: invitation,
      token: token,
      country_code: countryCode,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  registrationOtp: async (signId, registeredBy) => {
    const { baseAuth, registrationOtp } = ApiConfig;
    const url = baseAuth + registrationOtp;
    const params = {
      signId: signId, registeredBy
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  verifyRegistrationToken: async (authenticationToken) => {
    const token = authenticationToken
    const { baseAuth, verifyRegistrationToken } = ApiConfig;
    const url = baseAuth + verifyRegistrationToken;
    const headers = {
      Authorization: token,
      "Content-Type": "application/json",
    };
    return ApiCallGetVerifyRegistration(url, headers);
  },

  getOtp: async (signid, type) => {
    const { baseAuth, getOtp } = ApiConfig;
    const url = baseAuth + getOtp;
    const params = {
      email_or_phone: signid,
      type: type,
      "resend": true
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  verifyRegistrationOtp: async (signId, verification_code, registeredBy, token) => {
    const { baseAuth, verifyRegistrationOtp } = ApiConfig;
    const url = baseAuth + verifyRegistrationOtp;
    const params = {
      signId: signId, verification_code, token, registeredBy
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  getCode: async (signId, type, otp) => {
    const { baseAuth, getcode } = ApiConfig;
    const url = baseAuth + getcode;
    const params = {
      "email_or_phone": signId,
      "type": type,
      "otp": Number(otp)
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  forgotPassword: async (inputData, type, countryCode = "+91") => {
    const { baseAuth, forgotpassword } = ApiConfig;
    const url = baseAuth + forgotpassword;
    const fullPhonePayload = `${countryCode} ${inputData?.signId}`;
    const params = {
      email_or_phone: type === "phone" ? fullPhonePayload : inputData?.signId,
      verification_code: +inputData?.otp,
      new_password: inputData?.password,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  googleLogin: async (tokenResponse, captchaData) => {
    const { baseUrl, loginwithGoogle } = ApiConfig;
    const url = baseUrl + loginwithGoogle;
    // const { captcha_output, gen_time, lot_number, pass_token } = captchaData
    const params = {
      Token: tokenResponse?.access_token,
      type: 'google',
      // captcha_output, gen_time, lot_number, pass_token
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  signupwithGoogle: async (tokenResponse, captchaData, invitation) => {
    const { baseUrl, signupwithGoogle } = ApiConfig;
    const url = baseUrl + signupwithGoogle;
    // const { captcha_output, gen_time, lot_number, pass_token } = captchaData
    const params = {
      Token: tokenResponse?.access_token,
      type: 'google', referral_code: invitation
      // captcha_output, gen_time, lot_number, pass_token
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },



  getActivityLogs: async (skip, limit) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, activityLogs } = ApiConfig;
    const url = baseAuth + activityLogs;
    const params = {
      skip, limit
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },


  accessTokenSumsub: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, accessTokenSumsub } = ApiConfig;
    const url = baseAuth + accessTokenSumsub;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  setCurrency: async (currencyType) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, setCurrency } = ApiConfig;
    const url = baseAuth + setCurrency;
    const params = {
      currency: currencyType,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPut(url, params, headers);
  },



  getUserfunds: async (type) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, userfunds } = ApiConfig;
    const url = baseWallet + userfunds + `?wallet_type=${type}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  userP2pWallet: async () => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, userP2pWallet } = ApiConfig;
    const url = baseWallet + userP2pWallet;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  availableWalletTypes: async () => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, availableWalletTypes } = ApiConfig;
    const url = baseWallet + availableWalletTypes;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getPerticularWalletBalance: async (currencyId, fromWallet, toWallet) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, getPerticularWalletBalance } = ApiConfig;
    const url = baseWallet + getPerticularWalletBalance + `?fromWallet=${fromWallet}&toWallet=${toWallet}&currencyId=${currencyId}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getWalletBalance: async (currencyId, fromWallet) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, getWalletBalance } = ApiConfig;
    const url = baseWallet + getWalletBalance + `?fromWallet=${fromWallet}&currencyId=${currencyId}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  walletTransferHistory: async (skip, limit) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, walletTransferHistory } = ApiConfig;
    const url = baseWallet + walletTransferHistory + `?skip=${skip}&limit=${limit}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },
  bonusHistory: async (skip, limit) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, bonusHistory } = ApiConfig;
    const url = baseWallet + bonusHistory + `?skip=${skip}&limit=${limit}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  walletHistory: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseTrans, walletHistory } = ApiConfig;
    const url = baseTrans + walletHistory + `?skip=${skip}&limit=${limit}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  tradeHistory: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseTrans } = ApiConfig;
    const url = baseTrans + `trade-history?skip=${skip}&limit=${limit}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  blogList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, blogList } = ApiConfig;
    const url = baseAuth + blogList;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },
  launchpadTransHistory: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, launchpadTransHistory } = ApiConfig;
    const url = baseAuth + launchpadTransHistory;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },



  allOpenOrder: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange } = ApiConfig;
    const url = baseExchange + `all-open-orders?skip=${skip}&limit=${limit}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },


  getbannerdata: async () => {
    const { baseAdmin, bannerList } = ApiConfig;
    const url = baseAdmin + bannerList;
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallGet(url, headers);
  },


  generateAddress: async (generate, chain) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, generateAddress } = ApiConfig;
    const url = baseWallet + generateAddress;
    const params = {
      "generate": generate,
      "chain": chain
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPut(url, params, headers);
  },

  estimatedPortfolio: async (type) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, estimatedPortfolio } = ApiConfig;
    const url = baseWallet + estimatedPortfolio + `?walletType=${type}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  nexbAmount: async (baseCurrencyId, quoteCurrencyId, userId, usdtCoin) => {
    const token = sessionStorage.getItem("token");
    const { baseUrl, convertToken } = ApiConfig;
    const url = baseUrl + convertToken;
    const params = {
      userId: userId,
      base_Currency_id: baseCurrencyId,
      quote_Currency_id: quoteCurrencyId,
      amountToPay: usdtCoin,
    }
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },



  swapAmount: async (baseCurrencyId, quoteCurrencyId, userId, usdtCoin, nexbCoin) => {
    const token = sessionStorage.getItem("token");
    const { baseUrl, swapToken } = ApiConfig;
    const url = baseUrl + swapToken;
    const params = {
      userId: userId,
      base_Currency_id: baseCurrencyId,
      quote_Currency_id: quoteCurrencyId,
      amountToPay: usdtCoin,
      amountToBuy: nexbCoin,
      fromCurrency: "USDT",
      toCurrency: "NEXB",
      side: "BUY"
    }
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },



  withdrawalCurrency: async (walletAddress, amountValue, otp, selectedChain, signId, balance) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, withdrawalcurrencypath } = ApiConfig;
    const url = baseWallet + withdrawalcurrencypath;
    const params = {
      withdrawal_address: walletAddress,
      amount: amountValue,
      chain: selectedChain?.chain,
      coinName: selectedChain?.name,
      verification_code: +otp,
      email_or_phone: signId,
      usdt_balance: balance,
    };
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, params, headers);
  },

  walletTransfer: async (fromWallet, toWallet, currencyId, amount) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, walletTransfer } = ApiConfig;
    const url = baseWallet + walletTransfer;
    const params = {
      fromWallet, toWallet, currencyId, amount
    };
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, params, headers);
  },

  addkyc: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, identity } = ApiConfig;
    const url = baseAuth + identity;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPost(url, formData, headers);
  },

  categoryList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAdmin, categoryList } = ApiConfig;
    const url = baseAdmin + categoryList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getAnnouncementCategoryList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getAnnouncementCategoryList } = ApiConfig;
    const url = baseAuth + getAnnouncementCategoryList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getUpcominglpList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getUpcominglpList } = ApiConfig;
    const url = baseAuth + getUpcominglpList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getCancellpList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getCancellpList } = ApiConfig;
    const url = baseAuth + getCancellpList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getLiveListing: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getLiveListing } = ApiConfig;
    const url = baseAuth + getLiveListing;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getEndedListing: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getEndedListing } = ApiConfig;
    const url = baseAuth + getEndedListing;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getUserPurchingList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getUserPurchingList } = ApiConfig;
    const url = baseAuth + getUserPurchingList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getUserlpList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getUserlpList } = ApiConfig;
    const url = baseAuth + getUserlpList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  getAnnouncementList: async (id) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getAnnouncementList } = ApiConfig;
    const url = baseAuth + getAnnouncementList + `/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  userlpDetails: async (id) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, userlpDetails } = ApiConfig;
    const url = baseAuth + userlpDetails + `/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },
  subscriptionHistory: async (id) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, subscriptionHistory } = ApiConfig;
    const url = baseAuth + subscriptionHistory;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  tokenPurches: async (launchpadId, amountInvested) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, tokenPurches } = ApiConfig;
    const url = baseAuth + tokenPurches;
    const params = {
      launchpadId: launchpadId,
      amountInvested: +amountInvested,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  announcementView: async (id) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, announcementView } = ApiConfig;
    const url = baseAuth + announcementView + `/${id}`;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },


  favoriteCoin: async (pairId) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, favoriteCoin } = ApiConfig;
    const url = baseAuth + favoriteCoin;
    const params = {
      "pair_id": pairId
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  favoriteList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, favoriteList } = ApiConfig;
    const url = baseAuth + favoriteList;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },

  depositActiveCoins: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, depositActiveCoins } = ApiConfig;
    const url = baseAuth + depositActiveCoins;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },

  depositAddressList: async (chain) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, depositAddressList } = ApiConfig;
    const query = chain ? `?chain=${encodeURIComponent(chain)}` : "";
    const url = baseAuth + depositAddressList + query;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    return ApiCallGet(url, headers);
  },

  submitDepositProof: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, depositRequestSubmit } = ApiConfig;
    const url = baseAuth + depositRequestSubmit;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallPost(url, formData, headers);
  },

  depositRequestList: async ({ skip = 0, limit = 20, status } = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, depositRequestList } = ApiConfig;
    const query = new URLSearchParams();
    query.append("skip", skip);
    query.append("limit", limit);
    if (status) query.append("status", status);
    const url = `${baseAuth}${depositRequestList}?${query.toString()}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    return ApiCallGet(url, headers);
  },

  withdrawActiveCoins: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, withdrawActiveCoins } = ApiConfig;
    const url = baseAuth + withdrawActiveCoins;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },

  allCoins: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, allCoins } = ApiConfig;
    const url = baseAuth + allCoins;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },

  setSecurity: async (password, conPassword, verificationcode, email_or_phone) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, setSecurity } = ApiConfig;
    const url = baseAuth + setSecurity;
    const params = {
      new_password: password,
      confirm_password: conPassword,
      verification_code: verificationcode,
      email_or_phone: email_or_phone
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  updateSettings: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, updateSettings } = ApiConfig;
    const url = baseAuth + updateSettings;
    ConsoleLogs(TAG + ', updateSettings', `url : ' + ${url}`);
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    };
    return ApiCallPut(url, formData, headers);
  },

  editavatar: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, editavatar } = ApiConfig;
    const url = baseAuth + editavatar;
    ConsoleLogs(TAG + ', updateSettings', `url : ' + ${url}`);
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    };
    return ApiCallPut(url, formData, headers);
  },


  editusername: async (firstName, lastName) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, editusername } = ApiConfig;
    const url = baseAuth + editusername;
    const params = {
      "firstName": firstName,
      "lastName": lastName,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPut(url, params, headers);
  },

  editemail: async (emailId, eotp) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, editemail } = ApiConfig;
    const url = baseAuth + editemail;
    const params = {
      "emailId": emailId,
      "eotp": eotp,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPut(url, params, headers);
  },

  editPhone: async (mobileNumber) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, editPhone } = ApiConfig;
    const url = baseAuth + editPhone;
    const params = {
      "mobileNumber": mobileNumber,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPut(url, params, headers);
  },

  placeOrder: async (infoPlaceOrder, buyprice, buyamount, base_currency_id, quote_currency_id, side) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, placeOrder } = ApiConfig;
    const url = baseExchange + placeOrder;
    const params = {
      "order_type": infoPlaceOrder,
      "base_currency_id": base_currency_id,
      "quote_currency_id": quote_currency_id,
      "side": side,
      "price": +buyprice,
      "quantity": +buyamount
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  getPackageList: async () => {
    const token = sessionStorage.getItem("token");
    const { baseUserBot, getPackageList } = ApiConfig;
    const url = baseUserBot + getPackageList;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getActivePackage: async () => {
    const token = sessionStorage.getItem("token");
    const { baseUserBot, getActivePackage } = ApiConfig;
    const url = baseUserBot + getActivePackage;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getInvestment: async () => {
    const token = sessionStorage.getItem("token");
    const { baseUserBot, getInvestment } = ApiConfig;
    const url = baseUserBot + getInvestment;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  pastOrder: async (base_currency_id, quote_currency_id, skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, pastOrder } = ApiConfig;
    const url = baseExchange + pastOrder;
    const params = {
      "base_currency_id": base_currency_id,
      "quote_currency_id": quote_currency_id,
      "skip": skip,
      "limit": limit,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  depositHistory: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseTrans, depositHistory } = ApiConfig;
    const url = baseTrans + depositHistory;
    const params = {
      "skip": skip,
      "limit": limit,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  withdrawalHistory: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseTrans, withdrawalHistory } = ApiConfig;
    const url = baseTrans + withdrawalHistory;
    const params = {
      "skip": skip,
      "limit": limit,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  cancelOrder: async (orderId) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, cancelOrder } = ApiConfig;
    const url = baseExchange + cancelOrder;
    const params = {
      "order_id": orderId
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },


  cancelAllOrder: async () => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, cancel_all_order } = ApiConfig;
    const url = baseExchange + cancel_all_order;
    const params = {};
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  coinDetails: async (currency_id) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, coinDetails } = ApiConfig;
    const url = baseExchange + coinDetails;
    const params = {
      "currency_id": currency_id
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  update2fa: async (authType, code, verifyType) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, update2fa } = ApiConfig;
    const url = baseAuth + update2fa;
    const params = {
      type: authType,
      verification_code: Number(code),
      email_or_phone: verifyType
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPut(url, params, headers);
  },


  googleAuth: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, googleAuth } = ApiConfig;
    const url = baseAuth + googleAuth;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getHistoricalData: async (fromSymbol, toSymbol, from, to, chartResolution) => {
    const token = sessionStorage.getItem('token');
    const { baseExchange, getHistoricalData } = ApiConfig;
    const url = baseExchange + getHistoricalData;
    const params = {
      base_currency: fromSymbol,
      quote_currency: toSymbol,
      from: from,
      to: to,
      limit: 2000,
      chartResolution,
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },


  editBankDetails: async (accountType, bankName, holderName, accountNumber, ifscCode, branchAddress, id) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, editBankDetails } = ApiConfig;
    const url = baseAuth + editBankDetails;
    const params = {
      _id: id,
      account_type: accountType,
      bank_name: bankName,
      account_holder_name: holderName,
      account_number: accountNumber,
      ifsc_code: ifscCode,
      branch_name: branchAddress,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  editUpiDetails: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, editUpiDetails } = ApiConfig;
    const url = baseAuth + editUpiDetails;

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPut(url, formData, headers);
  },


  cryptoCompareApi: async (base, quote, to, resolution) => {
    const intervalByResolution = {
      histominute: "1m",
      histohour: "1h",
      histoday: "1d",
    };
    const interval = intervalByResolution[resolution] || "1m";
    const symbol = `${String(base || "").toUpperCase()}${String(quote || "").toUpperCase()}`;
    const params = new URLSearchParams({
      symbol,
      interval,
      limit: "1000",
    });
    const endTime = to ? Math.floor(Number(to) * 1000) : NaN;
    if (Number.isFinite(endTime) && endTime > 0) {
      params.set("endTime", String(endTime));
    }
    const url = `https://data-api.binance.vision/api/v3/klines?${params.toString()}`;
    const klines = await ApiCallGet(url, {});
    if (!Array.isArray(klines)) {
      return { Response: "Error", Data: { Data: [] } };
    }
    return {
      Data: {
        Data: klines.map((candle) => ({
          time: Math.floor(Number(candle[0]) / 1000),
          open: Number(candle[1]),
          high: Number(candle[2]),
          low: Number(candle[3]),
          close: Number(candle[4]),
          volume: Number(candle[5]),
          volumeto: Number(candle[5]),
        })),
      },
    };
  },


  getDetails: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, getDetails } = ApiConfig;
    const url = baseAuth + getDetails;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  inrDeposit: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, depositInr } = ApiConfig;
    const url = baseWallet + depositInr;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPost(url, formData, headers);
  },

  inrWithdrawal: async (withdrawAmount) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, withdrawalInr } = ApiConfig;
    const url = baseWallet + withdrawalInr;
    const params = {
      amount: withdrawAmount,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  getBankDetails: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAdmin, adminBankDetails } = ApiConfig;
    const url = baseAdmin + adminBankDetails;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getUserBankDetails: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, userBankDetails } = ApiConfig;
    const url = baseAuth + userBankDetails;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  quickBuySellHistory: async (skip, limit) => {
    const token = sessionStorage.getItem('token');
    const { baseSwap, quickBuySellHistory } = ApiConfig;
    const url = baseSwap + quickBuySellHistory + `?skip=${skip}&limit=${limit}`;
    const headers = { 'Content-Type': 'application/json', "Authorization": token };
    return ApiCallGet(url, headers);
  },

  baseCurrencyList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseSwap, baseCurrencyList } = ApiConfig;
    const url = baseSwap + baseCurrencyList;
    const headers = { 'Content-Type': 'application/json', "Authorization": token };
    return ApiCallGet(url, headers);
  },

  getConversionRate: async (from, receive) => {
    const token = sessionStorage.getItem('token');
    const { baseSwap, getConversionRate } = ApiConfig;
    const url = baseSwap + getConversionRate + `?from=${from}&receive=${receive}`;
    const headers = { 'Content-Type': 'application/json', "Authorization": token };
    return ApiCallGet(url, headers);
  },

  getApk: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAdmin, getApk } = ApiConfig;
    const url = baseAdmin + getApk;
    const headers = { 'Content-Type': 'application/json', "Authorization": token };
    return ApiCallGet(url, headers);
  },


  swapToken: async (fromWallet, toWallet, amount) => {
    const token = sessionStorage.getItem('token');
    const { baseSwap, quick_buy_sell } = ApiConfig;
    const url = baseSwap + quick_buy_sell;
    const params = {
      fromWallet, toWallet, amount
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  getPartnerName: async (partnerId) => {
    const token = sessionStorage.getItem("token");
    const { basePartner, getPartnerName } = ApiConfig;
    const url = basePartner + getPartnerName + `/${partnerId}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  packageList: async () => {
    const token = sessionStorage.getItem("token");
    const { baseEarning, packageList } = ApiConfig;
    const url = baseEarning + packageList;

    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  subscribedPackageList: async (skip, limit) => {
    const token = sessionStorage.getItem("token");
    const { baseEarning, subscribedPackageList } = ApiConfig;
    const url = baseEarning + subscribedPackageList + `?skip=${skip}&limit=${limit}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  earningPortfolio: async () => {
    const token = sessionStorage.getItem("token");
    const { baseEarning, earningPortfolio } = ApiConfig;
    const url = baseEarning + earningPortfolio;

    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  subscribeEarningPackage: async (planId, investAmount, walletType) => {
    const token = sessionStorage.getItem("token");
    const { baseEarning, subscribeEarningPackage } = ApiConfig;
    const url = baseEarning + subscribeEarningPackage;
    const params = { planId, investAmount, walletType };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  buyArbitrageBot: async (planId, walletType) => {
    const token = sessionStorage.getItem("token");
    const { baseUserBot, buyArbitrageBot } = ApiConfig;
    const url = baseUserBot + buyArbitrageBot;
    const params = { planId, walletType };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  addFunds: async (investAmount, walletType) => {
    const token = sessionStorage.getItem("token");
    const { baseUserBot, addFunds } = ApiConfig;
    const url = baseUserBot + addFunds;
    const params = { investAmount, walletType };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  getCvbotUserWallet: async (Id) => {
    const token = sessionStorage.getItem("token");
    const { baseCvbot, getCvbotUserWallet } = ApiConfig;
    const url = baseCvbot + getCvbotUserWallet + `/${Id}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },


  depositCvbotFunds: async (Id) => {
    const token = sessionStorage.getItem("token");
    const { baseCvbot, depositCvbotFunds } = ApiConfig;
    const url = baseCvbot + depositCvbotFunds;
    const params = { cvBotUuid: Id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  sendKginOtpOtp: async (kginNumber) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, sendkginotp } = ApiConfig;
    const url = baseAuth + sendkginotp;
    const params = { mobileNumber: Number(kginNumber) };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  verifyKginOtpOtp: async (kginNumber, kginOtp) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, verifykginotp } = ApiConfig;
    const url = baseAuth + verifykginotp;
    const params = {
      mobileNumber: Number(kginNumber),
      otp: kginOtp
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  notifications: async () => {
    const token = sessionStorage.getItem("token");
    const { baseNotification, notifiactionlist } = ApiConfig;
    const url = baseNotification + notifiactionlist;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },
  markasAllRead: async () => {
    const token = sessionStorage.getItem('token');
    const { baseNotification, markasAllRead } = ApiConfig;
    const url = baseNotification + markasAllRead;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  markasRead: async (notificationId) => {
    const token = sessionStorage.getItem("token");
    const { baseNotification, markasRead } = ApiConfig;
    const url = baseNotification + markasRead;
    const params = {
      notificationId
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },


  refferlsList: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, reffercode } = ApiConfig;
    const url = baseAuth + reffercode;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGet(url, headers);
  },

  getPairs: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getPairs } = ApiConfig;
    const url = baseAuth + getPairs;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getMemePairs: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getMemePairs } = ApiConfig;
    const url = baseAuth + getMemePairs;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  get_top_GL: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, get_top_GL } = ApiConfig;
    const url = baseAuth + get_top_GL;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },


  get_trending: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, get_trending } = ApiConfig;
    const url = baseAuth + get_trending;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  p2pCoinList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseCoin, p2pCoinList } = ApiConfig;
    const url = baseCoin + p2pCoinList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getCoinList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getCoinList } = ApiConfig;
    const url = baseAuth + getCoinList;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },




  assetAddList: async (projectName, contactName, telegramId, phoneNumber, emailAddress, referredBy, comments, countryCode, contractAddress) => {
    const { baseCoinList, coinListedDetails } = ApiConfig;
    const url = baseCoinList + coinListedDetails;
    const params = {
      projectName: projectName,
      contactName: contactName,
      telegramId: telegramId,
      phoneNumber: phoneNumber,
      emailId: emailAddress,
      referredBy: referredBy,
      comments: comments,
      countryCode: countryCode,
      smartContractAddress: contractAddress,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  addPartnerShipDetails: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { basePartner, partnerships } = ApiConfig;
    const url = basePartner + partnerships;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPost(url, formData, headers);
  },

  addUpiDetails: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, addUpiDetails } = ApiConfig;
    const url = baseAuth + addUpiDetails;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPost(url, formData, headers);
  },

  addBankDetails: async (account_type, bank_name, account_holder_name, account_number, ifsc_code, branch_name) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, addBankDetails } = ApiConfig;
    const url = baseAuth + addBankDetails;
    const params = { account_type, bank_name, account_holder_name, account_number, ifsc_code, branch_name }
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },


  registerPartner: async (emailAddress, password) => {
    const url = ApiConfig.baseUrl + 'v1/partnerShip/signUp';
    const params = {
      email: emailAddress,
      password: password
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  viewBlog: async (id) => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, viewBlog } = ApiConfig;
    const url = baseAuth + viewBlog + `/${id}`;

    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);

  },


  totalReferCount: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, total_refer_count } = ApiConfig;
    const url = baseAuth + total_refer_count;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getReferList: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, refer_list } = ApiConfig;
    const url = baseAuth + refer_list;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getLatestNews: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, getLatestNews } = ApiConfig;
    const url = baseAuth + getLatestNews;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  totalReferBalance: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, referral_balance } = ApiConfig;
    const url = baseAuth + referral_balance;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getjoiningbalance: async () => {
    const token = sessionStorage.getItem('token');
    const { baseAuth, joining_balance } = ApiConfig;
    const url = baseAuth + joining_balance;
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallGet(url, headers);
  },

  getCoinDetails: async (currency_id) => {
    const token = sessionStorage.getItem("token");
    const { baseExchange, coin_details } = ApiConfig;
    const url = baseExchange + coin_details;
    const params = {
      currency_id
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

  cancelWithdrawal: async (_id, amount, currency_id, fee) => {
    const token = sessionStorage.getItem("token");
    const { baseWallet, user_cancel_withdrawal } = ApiConfig;
    const url = baseWallet + user_cancel_withdrawal;
    const params = {
      _id, amount, currency_id, fee
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },


  verifyDeposit: async (status, chain, currency_id) => {
    const token = sessionStorage.getItem('token');
    const { baseWallet, verify_deposit } = ApiConfig;
    const url = baseWallet + verify_deposit;
    const params = {
      status, chain, currency_id
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  transfer_funds: async (chain, currency) => {
    const token = sessionStorage.getItem('token');
    const { baseWallet, transfer_funds } = ApiConfig;
    const url = baseWallet + transfer_funds;
    const params = {
      chain, currency
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  closePosition: async (positionId) => {
    const token = sessionStorage.getItem('token');
    const { baseFutures, closePosition } = ApiConfig;
    const url = baseFutures + closePosition;
    const params = {
      positionId
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },
  cancelFutureOrder: async (orderId) => {
    const token = sessionStorage.getItem('token');
    const { baseFutures, cancel } = ApiConfig;
    const url = baseFutures + cancel;
    const params = {
      orderId
    };
    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  placeFutureOrder: async (baseCurrency, quoteCurrency, marketType, side, quantity, price, leverage, takeProfit, stopLoss, isTpSl) => {
    const token = sessionStorage.getItem('token');
    const { baseFutures, order } = ApiConfig;
    const url = baseFutures + order;
    const params = {
      baseCurrency: baseCurrency,
      quoteCurrency: quoteCurrency,
      marketType: marketType,
      side: side,
      quantity: quantity,
      leverage: leverage,
    };

    if (marketType === "LIMIT") {
      params.price = price
    };

    if (isTpSl) {
      if (takeProfit > 0) {
        params.takeProfit = takeProfit
      };
      if (stopLoss < 0) {
        params.stopLoss = stopLoss
      };
    };


    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  placeReverseFutureOrder: async (baseCurrency, quoteCurrency, side, quantity, leverage) => {
    const token = sessionStorage.getItem('token');
    const { baseFutures, order } = ApiConfig;
    const url = baseFutures + order;
    const params = {
      baseCurrency: baseCurrency,
      quoteCurrency: quoteCurrency,
      marketType: "MARKET",
      side: side,
      quantity: quantity,
      leverage: leverage,
    };


    const headers = {
      'Content-Type': 'application/json',
      "Authorization": token,
    };
    return ApiCallPost(url, params, headers);
  },

  submitTicket: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseSupport, submitTicket } = ApiConfig;
    const url = baseSupport + submitTicket;
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    };

    return ApiCallPost(url, formData, headers);
  },

  getUserTickets: async () => {
    const token = sessionStorage.getItem("token");
    const { baseSupport, getUserTickets } = ApiConfig;
    const url = baseSupport + getUserTickets;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };

    return ApiCallGet(url, headers);
  },

  replyTicket: async (messagerply, id) => {
    const token = sessionStorage.getItem("token");
    const { baseSupport, replyTicket } = ApiConfig;
    const url = baseSupport + replyTicket;
    const params = {
      replyBy: 1,
      query: messagerply,
      ticket_id: id,

    }
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };

    return ApiCallPost(url, params, headers);
  },

  getReferredUserData: async (code) => {
    const url = `https://cvtoken.us/stake/api/user-data/${code}`
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallGet(url, headers);
  },





  // P2P Routes Starts Here



  getCurrency: async () => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getCurrency } = ApiConfig;
    const url = baseP2p + getCurrency;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getFiatCurrency: async () => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getFiatCurrency } = ApiConfig;
    const url = baseP2p + getFiatCurrency;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getAllPaymentMethods: async () => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getAllPaymentMethods } = ApiConfig;
    const url = baseP2p + getAllPaymentMethods;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  p2pSellOrderForBuyer: async (params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, p2pSellOrderForBuyer } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.fiat) queryParams.append('fiat', params.fiat);
    if (params.crypto) queryParams.append('crypto', params.crypto);
    if (params.paymentType && params.paymentType !== 'All payments') queryParams.append('paymentType', params.paymentType);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    const url = baseP2p + p2pSellOrderForBuyer + (queryParams.toString() ? `?${queryParams.toString()}` : '');
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },
  p2pBuyOrderForSeller: async (params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, p2pBuyOrderForSeller } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.fiat) queryParams.append('fiat', params.fiat);
    if (params.crypto) queryParams.append('crypto', params.crypto);
    if (params.paymentType && params.paymentType !== 'All payments') queryParams.append('paymentType', params.paymentType);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    const url = baseP2p + p2pBuyOrderForSeller + (queryParams.toString() ? `?${queryParams.toString()}` : '');
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getUserPaymentMethods: async () => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getUserPaymentMethods } = ApiConfig;
    const url = baseP2p + getUserPaymentMethods;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getPaymentMethodFields: async (id) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getPaymentMethodFields } = ApiConfig;
    const url = baseP2p + getPaymentMethodFields + `?id=${id}`;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getPairPrice: async (crypto, fiat) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getPairPrice } = ApiConfig;
    const url = baseP2p + getPairPrice + `?crypto=${crypto}&fiat=${fiat}`;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getUserAds: async (params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getUserAds } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.side) queryParams.append('side', params.side);
    if (params.status) queryParams.append('status', params.status);
    if (params.fiatCurrency) queryParams.append('fiatCurrency', params.fiatCurrency);
    if (params.qouteCurrency) queryParams.append('qouteCurrency', params.qouteCurrency);
    const url = baseP2p + getUserAds + (queryParams.toString() ? `?${queryParams.toString()}` : '');
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  closeAd: async (adId, reason = '') => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, closeAd } = ApiConfig;
    const url = baseP2p + closeAd;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    const payload = { adId };
    if (reason && reason.trim()) {
      payload.reason = reason.trim();
    }
    return ApiCallPost(url, payload, headers);
  },

  updateAdStatus: async (adId, isOnline) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, updateAdStatus } = ApiConfig;
    const url = baseP2p + updateAdStatus;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { adId, isOnline }, headers);
  },

  addUserPaymentMethod: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, addUserPaymentMethod } = ApiConfig;
    const url = baseP2p + addUserPaymentMethod;
    const headers = {
      "Content-Type": "multipart/form-data",
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  deleteUserPaymentMethod: async (paymentMethodId) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, deleteUserPaymentMethod } = ApiConfig;
    const url = baseP2p + deleteUserPaymentMethod;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { paymentMethodId }, headers);
  },

  createAd: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, createAd } = ApiConfig;
    const url = baseP2p + createAd;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },
  buyFromAd: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, buyFromAd } = ApiConfig;
    const url = baseP2p + buyFromAd;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  sellFromAd: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, sellFromAd } = ApiConfig;
    const url = baseP2p + sellFromAd;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  getP2pOrderDetails: async (orderId) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getP2pOrderDetails } = ApiConfig;
    const url = baseP2p + getP2pOrderDetails + `/${orderId}`;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  getP2pOrders: async (params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getP2pOrders } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.side) queryParams.append('side', params.side);
    if (params.crypto) queryParams.append('crypto', params.crypto);
    if (params.fiat) queryParams.append('fiat', params.fiat);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    const url = baseP2p + getP2pOrders + (queryParams.toString() ? `?${queryParams.toString()}` : '');
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  // ============ P2P ORDER ACTIONS ============

  // Buyer marks payment as completed (with optional payment proof)
  markPaymentCompleted: async (orderId, paymentProof = null) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, markPaymentCompleted } = ApiConfig;
    const url = baseP2p + markPaymentCompleted;

    const formData = new FormData();
    formData.append('orderId', orderId);
    if (paymentProof) {
      formData.append('paymentProof', paymentProof);
    }

    const headers = {
      'Authorization': token
      // Note: Don't set Content-Type for FormData, let browser set it with boundary
    };
    return ApiCallPost(url, formData, headers);
  },

  // Seller releases crypto after verifying payment
  releaseCrypto: async (orderId) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, releaseCrypto } = ApiConfig;
    const url = baseP2p + releaseCrypto;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId }, headers);
  },

  // Buyer cancels order (only PENDING_PAYMENT status)
  cancelP2pOrder: async (orderId, cancelReason = '') => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, cancelP2pOrder } = ApiConfig;
    const url = baseP2p + cancelP2pOrder;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId, cancelReason }, headers);
  },

  // Buyer raises dispute (only after PAID status)
  buyerRaiseDispute: async (orderId, reason) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, buyerDispute } = ApiConfig;
    const url = baseP2p + buyerDispute;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId, reason }, headers);
  },

  // Seller raises dispute (only after PAID status)
  sellerRaiseDispute: async (orderId, reason) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, sellerDispute } = ApiConfig;
    const url = baseP2p + sellerDispute;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId, reason }, headers);
  },

  getP2pProfile: async (userId = null) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getP2pProfile } = ApiConfig;
    let url = baseP2p + getP2pProfile;
    if (userId) {
      url += `?userId=${userId}`;
    }
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  // ============ P2P CHAT APIs ============

  // Send text message
  sendChatMessage: async (orderId, message) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, sendChatMessage } = ApiConfig;
    const url = baseP2p + sendChatMessage;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId, message }, headers);
  },

  // Upload chat image
  uploadChatImage: async (orderId, file) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, uploadChatImage } = ApiConfig;
    const url = baseP2p + uploadChatImage;

    const formData = new FormData();
    formData.append('orderId', orderId);
    formData.append('image', file);

    const headers = {
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  // Get chat history
  getChatHistory: async (orderId, params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getChatHistory } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.before) queryParams.append('before', params.before);
    const url = baseP2p + getChatHistory + `/${orderId}` + (queryParams.toString() ? `?${queryParams.toString()}` : '');
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  // Mark chat messages as read
  markChatAsRead: async (orderId) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, markChatRead } = ApiConfig;
    const url = baseP2p + markChatRead;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { orderId }, headers);
  },

  // Get unread message count
  getChatUnreadCount: async (orderId = null) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, getChatUnreadCount } = ApiConfig;
    let url = baseP2p + getChatUnreadCount;
    if (orderId) {
      url += `?orderId=${orderId}`;
    }
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallGet(url, headers);
  },

  // Delete chat message
  deleteChatMessage: async (messageId) => {
    const token = sessionStorage.getItem("token");
    const { baseP2p, deleteChatMessage } = ApiConfig;
    const url = baseP2p + deleteChatMessage;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': token
    };
    return ApiCallPost(url, { messageId }, headers);
  },

  // Copy Trading (user website)
  copyTradingMasters: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingMasters } = ApiConfig;
    const url = baseAuth + copyTradingMasters;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    return ApiCallGet(url, headers);
  },

  copyTradingMasterDetail: async (masterId) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingMaster } = ApiConfig;
    const url = baseAuth + copyTradingMaster + masterId;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    return ApiCallGet(url, headers);
  },

  copyTradingFollow: async (master_id) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingFollow } = ApiConfig;
    const url = baseAuth + copyTradingFollow;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallPost(url, { master_id }, headers);
  },

  copyTradingUnfollow: async (master_id) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingUnfollow } = ApiConfig;
    const url = baseAuth + copyTradingUnfollow;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallPost(url, { master_id }, headers);
  },

  copyTradingMyFollowing: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingMyFollowing } = ApiConfig;
    const url = baseAuth + copyTradingMyFollowing;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallGet(url, headers);
  },

  copyTradingHistory: async (params = {}) => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingHistory } = ApiConfig;
    const queryParams = new URLSearchParams();
    if (params.skip !== undefined && params.skip !== null) queryParams.append("skip", params.skip);
    if (params.limit !== undefined && params.limit !== null) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);
    if (params.master_id) queryParams.append("master_id", params.master_id);
    const url = baseAuth + copyTradingHistory + (queryParams.toString() ? `?${queryParams.toString()}` : "");
    const headers = {
      "Content-Type": "application/json",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallGet(url, headers);
  },

  copyTradingPnl: async () => {
    const token = sessionStorage.getItem("token");
    const { baseAuth, copyTradingPnl } = ApiConfig;
    const url = baseAuth + copyTradingPnl;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    };
    return ApiCallGet(url, headers);
  },

};

export default AuthService;
